<div mat-dialog-title>
  <div class="title-icon">
    <mat-icon>mic</mat-icon>
  </div>
  <div class="title-text">{{ 'microphone_settings.title' | transloco }}</div>
</div>

<mat-dialog-content class="mat-typography">
  <div class="settings-section">
    <mat-slide-toggle
      (change)="toggleMetadata()"
      [checked]="(showMessageMetadata$ | async) === false"
      class="toggle">
      {{ 'microphone_settings.compact_message_mode' | transloco }}
    </mat-slide-toggle>
  </div>

  @if (this.kit | async) {
    <!-- Microphones Section -->
    <div class="microphones-section">
      <h3 class="section-title">{{ 'microphone_settings.microphones' | transloco }}</h3>
      
      <div class="microphones-list">
        @for (mic of microphones(); track mic.mic_id) {
          <div class="microphone-card" 
               [class.editing]="editingState().micId === mic.mic_id"
               [class.online]="mic.isActive"
               [class.offline]="!mic.isActive">
            <!-- Microphone Header -->
            <div class="mic-header">
              <div class="mic-icon-wrapper">
                <i class="fa fa-microphone mic-icon" [style.color]="editingState().micId === mic.mic_id ? editingState().color : mic.color_hex"></i>
                <!-- Status Indicator -->
                <div class="status-indicator" 
                     [class.active]="mic.isActive"
                     [attr.title]="mic.isActive ? ('microphone_settings.status_active' | transloco) : ('microphone_settings.status_offline' | transloco)">
                </div>
              </div>
              
              <!-- Name Display/Edit -->
              <div class="mic-name-section">
                @if (editingState().micId !== mic.mic_id) {
                  <div class="mic-name" (click)="startEditing(mic.mic_id)">
                    {{ mic.displayName || mic.name || ('microphone_settings.unnamed_mic' | transloco) }}
                  </div>
                } @else {
                  <input
                    class="mic-name-input"
                    type="text"
                    [ngModel]="editingState().name"
                    (ngModelChange)="updateEditingName($event)"
                    (keyup.enter)="saveAndClose(mic)"
                    (keyup.escape)="cancelEditing()"
                    (focus)="selectAllText($event)"
                    maxlength="25"
                    pattern="[a-zA-Z0-9 ]*"
                    autofocus />
                }
              </div>

              <button mat-icon-button 
                      class="edit-button"
                      [class.save-button]="editingState().micId === mic.mic_id"
                      (click)="editingState().micId !== mic.mic_id ? startEditing(mic.mic_id) : saveAndClose(mic)">
                <mat-icon>{{ editingState().micId !== mic.mic_id ? 'edit' : 'check' }}</mat-icon>
              </button>
            </div>

            @if (editingState().micId === mic.mic_id) {
              <div class="color-palette">
                <div class="color-grid">
                  @for (color of colorList; track color) {
                    <button
                      type="button"
                      class="color-button"
                      [class.selected]="color === editingState().color"
                      [style.background-color]="color"
                      [attr.aria-label]="colorNames[color]"
                      (click)="changeColor(mic, color)"
                      (mousedown)="$event.preventDefault()">
                      @if (color === editingState().color) {
                        <span class="check-icon">
                          <mat-icon>check</mat-icon>
                        </span>
                      }
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        }

      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'microphone_settings.close' | transloco }}</button>
</mat-dialog-actions>